export const appendComment = (value: string, oldValue?: string | null) => {
  if (oldValue) return `${oldValue}<p><br></p>${value}`;
  return value;
};
